import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Map, TileLayer, Popup, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// react-leaflet does not include default markers
// https://github.com/PaulLeCam/react-leaflet/issues/453
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const MarkerWithOpenPopup = props => {
  const initMarker = ref => {
    if (ref) {
      ref.leafletElement.openPopup();
    }
  };
  return <Marker ref={initMarker} {...props}/>;
};

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '2rem',
    width: '100%',
    height: '100%',
  },  
  title: {
    marginBottom: '1rem',
    color: theme.palette.primary.main,  
  },
  mapContainer: {
    height: '400px',
    width: '100%',
  },
}));

const LocationMap = ({isLoading, premises, selectedPremise}) => {
  const classes = useStyles();
  if (isLoading || premises.length === 0) {
    return null;
  }
  const premise = premises[selectedPremise];
  const position = [premise.latitude, premise.longitude];
  return (
    <div className={classes.root}>
      <Map center={position} zoom={16} className={classes.mapContainer}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        <MarkerWithOpenPopup aria-label="Map marker of primary address" position={position}>
          <Popup aria-label={premise.formatted_address}>{premise.formatted_address}</Popup>
        </MarkerWithOpenPopup>
      </Map>
    </div>
  );
};

LocationMap.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  premises: PropTypes.array.isRequired,
  selectedPremise: PropTypes.number.isRequired,
};

export default LocationMap;
